import { useState, useEffect } from 'react'
import StaggeredMenu from './StaggeredMenu'

const navLinks = [
  { label: 'Home', link: '/' },
  { label: 'Services', link: '/services' },
  { label: 'Solutions', link: '/solutions' },
  { label: 'Portfolio', link: '/portfolio' },
  { label: 'Process', link: '/process' },
  { label: 'About', link: '/about' },
  { label: 'Pricing', link: '/pricing' },
  { label: 'Contact', link: '/contact' },
]

const socialLinks = [
  { label: 'Twitter', link: 'https://twitter.com' },
  { label: 'LinkedIn', link: 'https://linkedin.com' },
  { label: 'Instagram', link: 'https://www.instagram.com/akrlabs_official/' },
]

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50)
    }
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <>
      <div 
        className={`fixed top-0 left-0 right-0 h-[88px] z-[90] transition-all duration-500 ${
          isScrolled ? 'glass border-b-2 border-solid border-[var(--color-sketch-border)]' : 'bg-transparent'
        }`} 
      />
      <StaggeredMenu
        items={navLinks}
        socialItems={socialLinks}
        isFixed={true}
        colors={['var(--color-bg-secondary)', 'var(--color-red)']}
      />
    </>
  )
}

